import { getSocket } from '@/socket/socket';
import { defineStore } from 'pinia';
import { useExportStore } from './export';


export const useConnnectionStore = defineStore('socket-connection', () => {
  const socket = getSocket();

  const bindEvents = () => {
    socket.on('DATA_EXPORT_CREATED', data => {
      const exportStore = useExportStore();
      exportStore.setExportFinishedStatus(data.identifier, data.error);
      socket.off();
      socket.close();
    });
  
    socket.on('disconnect', () => {
      // console.log(`disconnect`);
    });
  };

  const connect = () => {
    socket.connect();
  };

  return {
    connect,
    bindEvents
  };
});
